import React, { FC, useRef } from 'react';
import * as S from './styled';
import { getWeeksCountToReachTheGoal } from '@helpers';
import { useT } from '@hooks';
import styled from 'styled-components';
import { fadeIn } from 'styles/animations';
import { Typography } from 'UI';
import { Alert, Card } from './components';
import { CHART_TYPE } from './types';
import { usePositions, useDates } from './helper';
import { CIRCLE2_DELAY } from './constants';

interface Props {
	currentWeight?: string;
	targetWeight?: string;
	deltaWeight?: number;
	weightUnit?: string;
	endDate?: string;
	addDays?: number;
}

const Container = styled.div`
	position: relative;
`;

const Dates = styled.div<{ delay: number; offsetLeft1: number; offsetLeft2: number }>`
	position: absolute;
	bottom: 20px;
	left: -30px;

	& span:nth-child(1) {
		position: absolute;
		bottom: 0;
		left: ${({ offsetLeft1 }) => offsetLeft1}px;
		opacity: 0;
		animation: ${fadeIn} 0.7s 0.5s ease-in-out forwards;
	}

	& span:nth-child(2) {
		position: absolute;
		bottom: 0;
		left: ${({ offsetLeft2 }) => offsetLeft2}px;
		opacity: 0;
		animation: ${fadeIn} 0.7s ${({ delay }) => delay}s ease-in-out forwards;
	}
`;

export const Chart: FC<Props> = props => {
	const { currentWeight, targetWeight, deltaWeight, weightUnit, endDate, addDays = 0 } = props;
	const { T } = useT();
	const containerRef = useRef<HTMLDivElement>(null);
	const { circle1, circle2 } = usePositions(containerRef) ?? {};
	const dates = useDates(
		getWeeksCountToReachTheGoal(Number(currentWeight), Number(targetWeight)),
		addDays,
		true,
	);

	return (
		<S.Chart>
			<S.ChartTitle>
				<p>Based on your answers and personal goals, you can reach your goal weight of</p>
				<h4>
					{deltaWeight} {weightUnit} by {endDate}
				</h4>
				<p>And get ready to take tons of breathtaking vacation photos</p>
			</S.ChartTitle>
			<Container ref={containerRef}>
				<Card type={CHART_TYPE.V3} />
				<Alert
					{...circle1}
					weight={Number(currentWeight)}
					weightUnit={T(`value_${weightUnit}`)}
					delay={0.5}
				/>
				<Alert
					{...circle2}
					goal
					weight={Number(targetWeight)}
					weightUnit={T(`value_${weightUnit}`)}
					delay={CIRCLE2_DELAY[CHART_TYPE.V3]}
				/>
				<Dates
					delay={CIRCLE2_DELAY[CHART_TYPE.V3]}
					offsetLeft2={circle2?.offsetLeft ?? 0}
					offsetLeft1={circle1?.offsetLeft ?? 0}
				>
					{dates.map(date => (
						<Typography color='white' size={13} weight='bold' whiteSpace='nowrap' key={date}>
							{date}
						</Typography>
					))}
				</Dates>
			</Container>
		</S.Chart>
	);
};
